export let mountCount = 0;
export const increment = () => ++mountCount;
export const decrement = () => --mountCount;